"use strict";
exports.__esModule = true;
exports.prices = void 0;
exports.prices = {
    workspace: {
        monthly: 9.99,
        yearly: 100
    },
    individual: {
        monthly: 9.99,
        yearly: 100
    },
    fileManager: {
        monthly: 5,
        yearly: 50
    },
    externalShare: {
        monthly: 5,
        yearly: 50
    },
    boardChat: {
        monthly: 2,
        yearly: 20
    },
    approvals: {
        monthly: 2,
        yearly: 20
    },
    boardKey: {
        monthly: 2,
        yearly: 20
    },
    analytics: {
        monthly: 3,
        yearly: 30
    },
    officeFileViewer: {
        monthly: 5,
        yearly: 50
    },
    archiveManager: {
        monthly: 2,
        yearly: 20
    },
    durations: {
        monthly: 2,
        yearly: 20
    },
    galleryView: {
        monthly: 1.5,
        yearly: 15
    },
    tableView: {
        monthly: 5,
        yearly: 50
    },
    polls: {
        monthly: 2,
        yearly: 20
    },
    advancedCardCovers: {
        monthly: 3,
        yearly: 30
    },
    showOnCardFront: {
        monthly: 1.5,
        yearly: 15
    },
    bookmarks: {
        monthly: 1,
        yearly: 10
    },
    forms: {
        monthly: 3,
        yearly: 30
    },
    savedFilters: {
        monthly: 1,
        yearly: 10
    },
    conditionalListColors: {
        monthly: 2,
        yearly: 20
    }
};
//# sourceMappingURL=prices.js.map